import { createColorHash } from "app/common/ui/colorHash"
import { TagVM } from "app/models/tags"
import { array, ord, string } from "fp-ts"
import { pipe } from "fp-ts/function"
import { FC } from "react"
import { IoIosCheckmarkCircle } from "react-icons/io"
import { tw } from "twind"
import { css } from "twind/css"

type Orientation = "horizontal" | "vertical"

interface TagListProps {
  orientation?: Orientation
  tags: Array<TagVM>
}

export const TagList: FC<TagListProps> = ({ orientation = "horizontal", tags }) => {
  const colorHash = createColorHash()

  return pipe(
    tags,
    array.sort(ord.contramap<string, TagVM>((t) => t.name)(string.Ord)),
    array.map((tag) => (
      <li
        className={tw(
          `whitespace-nowrap`,
          `font-semibold`,
          `flex items-center gap-1`,
          css`
            color: ${colorHash.hex(tag.slug)};
          `
        )}
        key={tag.slug}
      >
        <IoIosCheckmarkCircle className={tw(`text-lg`)} /> {tag.name}
      </li>
    )),
    (lis) =>
      array.isNonEmpty(lis) ? (
        <ul
          className={tw(
            `text-sm`,
            `flex(& wrap) gap-4`,
            orientation === "vertical" && "flex-col gap-1",
            `mt-2`
          )}
        >
          {lis}
        </ul>
      ) : null
  )
}
